import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log("SalesTargetController connected");
  }

  updateSalesTargetAmount(event) {
    const salesTargetId = event.target.parentElement.dataset.salesTargetId;
    const amount = event.target.value;
    console.log(salesTargetId, amount);
    fetch(`/sales_targets/${salesTargetId}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")
          .content
      },
      body: JSON.stringify({ sales_target: { amount } })
    });
  }
}
